import React, { Suspense } from 'react'
import { Container } from 'react-bootstrap'
import {
    Redirect,
    Route,
    Switch
} from 'react-router-dom'
import routes from 'src/router/routes'
import FadeIn from 'react-fade-in';
// import mapapanama from 'src/assets/panama.svg'

const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
)

const TheContent = () => {
    return (
        <div className="App-content">
            <Container fluid >
                <Suspense fallback={loading}>
                    <Switch>
                        {routes.map((route, idx) => {
                            return route.component && (
                                <Route
                                    key={idx}
                                    path={route.path}
                                    exact={route.exact}
                                    name={route.name}
                                    render={props => (
                                        <FadeIn transitionDuration={700}>
                                            <route.component {...props} />
                                        </FadeIn>
                                    )} />
                            )
                        })}
                        <Redirect from="/" to="/inicio" />
                    </Switch>
                </Suspense>
            </Container>
        </div>
    )
}

export default TheContent
